module.exports = __webpack_public_path__ + "static/media/stockhausen_haum_17.49f0ece6.jpg";